<template>
    <div class="profile-skeleton" aria-hidden="true">
        <div class="profile-form">
            <div class="r-i-name-group">
                <div class="profile-field">
                    <div class="profile-field-label profile-skeleton-label" style="--skeleton-label-width: 96px;">
                        {{ $t('m.fNameInput') }}
                    </div>
                    <input class="r-i-input profile-skeleton-input" type="text" disabled>
                </div>
                <div class="profile-field">
                    <div class="profile-field-label profile-skeleton-label" style="--skeleton-label-width: 92px;">
                        {{ $t('m.lNameInput') }}
                    </div>
                    <input class="r-i-input profile-skeleton-input" type="text" disabled>
                </div>
            </div>

            <div class="profile-field">
                <div class="profile-field-label profile-skeleton-label" style="--skeleton-label-width: 104px;">
                    {{ $t('m.emailInput') }}
                </div>
                <input class="r-i-input profile-skeleton-input" type="text" disabled>
            </div>

            <div class="profile-field">
                <div class="profile-field-label profile-skeleton-label" style="--skeleton-label-width: 108px;">
                    {{ $t('m.phonePlaceholder') }}
                </div>
                <input class="r-i-input profile-skeleton-input" type="text" disabled>
            </div>

            <div class="profile-field">
                <div class="profile-field-label profile-skeleton-label" style="--skeleton-label-width: 92px;">
                    {{ $t('m.postCodeInput') }}
                </div>
                <input class="r-i-input profile-skeleton-input" type="text" disabled>
            </div>

            <button class="primary-btn profile-save-btn profile-skeleton-save invalid" type="button" disabled>
                {{ $t('m.profileSave') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProfileSkeleton",
};
</script>

<style scoped>
.profile-skeleton {
    width: 100%;
    pointer-events: none;
}

.profile-skeleton-label {
    position: relative;
    color: transparent !important;
}

.profile-skeleton-label::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: var(--skeleton-label-width);
    height: 18px;
    border-radius: 4px;
    background: #e0e0e0;
    animation: pulse 1.5s infinite ease-in-out;
}

.profile-skeleton-input {
    background: #e0e0e0;
    border-color: transparent;
    box-shadow: none;
    color: transparent !important;
    -webkit-text-fill-color: transparent;
    caret-color: transparent;
    animation: pulse 1.5s infinite ease-in-out;
}

.profile-skeleton-save {
    box-shadow: none;
    color: transparent !important;
    animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
    0% {
        opacity: 0.6;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0.6;
    }
}
</style>
